import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

import {
    DEFAULT_LOCALE,
    type DisplayMessagesInterface,
    getDisplayMessages,
    getLocale,
    getUserAccount,
} from '../../configuration';
import type { AppDispatch, RootState } from '../../configuration/setup/store';
import { fetchGeoBooked } from '../fetchData/fetchGeoBooked';
import { eventFactory } from '../livemonitorCommunication/eventFactory';
import { MessageHandlerContainer, sendMessage } from '../livemonitorCommunication/MessageHandler';
import { useEffectOnce } from './hooks';
import { RoutePlannerContainer } from './RoutePlanner';

interface RoutePlanningProps {
    accountId: string;
    displayMessages: DisplayMessagesInterface;
    loadGeoBooked: () => {};
    userLocale: string;
}

const App = (props: RoutePlanningProps): React.JSX.Element | null => {
    const { displayMessages, loadGeoBooked, userLocale } = props;

    useEffectOnce(() => {
        sendMessage(eventFactory.widgetLoaded());
        loadGeoBooked();
    });
    if (!displayMessages) {
        return null;
    }

    return (
        <IntlProvider defaultLocale={DEFAULT_LOCALE} key={userLocale} locale={userLocale} messages={displayMessages}>
            <MessageHandlerContainer />
            <ApplicationLayout>
                <RoutePlannerContainer />
            </ApplicationLayout>
        </IntlProvider>
    );
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    loadGeoBooked: () => dispatch(fetchGeoBooked),
});

const mapStateToProps = (state: RootState) => ({
    accountId: getUserAccount(state),
    displayMessages: getDisplayMessages(state),
    userLocale: getLocale(state),
});

export const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App);
